import { Component, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';


export const DATE_TIME_PICKER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DateTimePickerComponent),
    multi: true,
};


@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    providers: [DATE_TIME_PICKER_VALUE_ACCESSOR]
})
export class DateTimePickerComponent implements ControlValueAccessor {
    date: Date;
    time: number;

    @ViewChild('DateModel') dateModel: NgModel;
    @ViewChild('TimeModel') timeModel: NgModel;

    onChange: (value: Date) => void;
    onTouched: () => void;

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        const method = isDisabled ? 'disable' : 'enable';
        this.dateModel.control[method]();
        this.timeModel.control[method]();
    }

    writeValue(value: any): void {
        if (typeof value === 'string')
            value = new Date(value);

        if (value instanceof Date) {
            this.date = new Date(
                value.getFullYear(),
                value.getMonth(),
                value.getDate()
            );
            this.time = value.getTime() - this.date.getTime();
        } else {
            this.date = this.time = undefined;
        }
    }

    calculateValue() {
        this.onChange(
            this.date ?
                new Date(this.date.getTime() + (this.time ?? 0)) :
                null
        );
    }
}
